import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'

const handler = object(null, {
  task: (
    element,
    event
  ) => {
    preventDefault(event)
    const { ownerDocument } = element
    const requires = element.dataset.requires

    const meta = one(requires, ownerDocument)
    if (meta === null) {
      return
    }

    const { dataset } = meta
    const { url = '' } = dataset
    if (url === '') {
      return
    }

    globals.ea_link(url, '', null)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}